import SimpleCompletePage from 'features/membership/components/simple/SimpleCompletePage';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import {
  membershipPluginPageTemplateOptionState,
  SimplePageTemplateOptionKey
} from 'features/membership/libs/recoil/selector';
import { PageTemplateOption } from 'features/membership/types';
import { digiclueplusRedirectParamsAtom } from 'libs/recoil/atom';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

/**
 * 会員登録完了
 */
const MintSignupComplete: FC = () => {
  const pageTemplateOptions = useRecoilValue<
    Record<SimplePageTemplateOptionKey, PageTemplateOption> | undefined
  >(membershipPluginPageTemplateOptionState(TEMPLATE_ALIAS_CODE.MINT));

  // Recoilに初期値である空文字以外に設定されている場合は、デジクルプラスへリダイレクトする
  const digiclueplusRedirectParams = useRecoilValue(
    digiclueplusRedirectParamsAtom
  );
  if (digiclueplusRedirectParams.wall_path !== '') {
    return <Navigate to="/redirect/digiclueplus" />;
  }

  if (!pageTemplateOptions) {
    return <Navigate to="/" />;
  }
  return (
    <SimpleCompletePage
      templateOptions={pageTemplateOptions}
      isSignupCompletePage
    />
  );
};

export default MintSignupComplete;
